module.exports = __webpack_public_path__ + "static/media/app icon (6).d82fab4d.png";